import router from '@/router';
import scheduledMaintenanceDlg
  from "@/views/maintenance/scheduledMaintenance/scheduledMaintenanceDlg/scheduledMaintenanceDlg.vue";
import {MaintenanceMixin} from "@/mixins/Maintenance";

export default {
  name: 'scheduledMaintenanceList',
  components: {
    scheduledMaintenanceDlg
  },
  mixins: [MaintenanceMixin],
  data() {
    return {
      loading: true,
      search: '',
      headers: [
        {
          text: 'Title',
          align: 'start',
          sortable: false,
          value: 'title',
        },
        {
          text: 'Cadence',
          align: 'start',
          value: 'cadence',
        },
        {
          text: 'Recurring Repeat Type',
          align: 'start',
          value: 'recurringRepeatType',
        },
        {
          text: 'Category',
          align: 'start',
          value: 'category',
        },
        {
          text: 'Next Maintenance',
          align: 'start',
          value: 'nextMaintenance',
        },
        {
          text: 'End Maintenance',
          align: 'start',
          value: 'endDate',
        },
        {
          text: 'Maintained By',
          align: 'start',
          value: 'maintainedBy',
        },
      ],
    };
  },
  async created() {
    this.loading = true;
    await this.$store.dispatch('getScheduledMaintenance');
    await this.$store.dispatch('getMaintenanceTypes');

    await this.$store.dispatch('getMaintenanceUsers');
    await this.$store.dispatch('getMaintenanceVendors');

    await this.$store.dispatch('getVendors');
    await this.$store.dispatch('getMaintenanceCategories');
    this.loading = false;
  },
  computed: {
    scheduledMaintenanceRequests() {
      return this.$store.state.maintenanceModule.scheduledMaintenance;
    },
    maintenanceTypes() {
      return this.$store.state.maintenanceModule.maintenanceTypes;
    },
    currentVendors() {
      return this.$store.state.additionalServicesModule.currentVendors;
    },
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    maintenanceCategories() {
      return this.$store.state.maintenanceModule.maintenanceCategories;
    },
  },
  methods: {
    handleClickMaintenanceRequest(row) {
      router.push('/scheduledMaintenance/' + row.id.toString());
    },
    createScheduledMaintenance() {
      this.$refs.scheduledMaintenanceDlg.open("create");
    }
  },
};